import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DATA_EVENT, DATA_EVENT_SELECTOR, DATA_VALUE, GlobalEventName } from './useGlobalClickHandler.enum';
import { HistoryEvent } from './useGlobalClickHandler.types';

export function useGlobalClickHandler() {
	const history = useHistory();

	useEffect(() => {
		document.addEventListener('click', handleClick, true);
		return () => {
			document.removeEventListener('click', handleClick, true);
		};
	}, []);

	const handleClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;
		const clickableElement = target.closest<HTMLElement>(DATA_EVENT_SELECTOR);

		if (!clickableElement) return;

		const eventName = clickableElement.getAttribute(DATA_EVENT) as GlobalEventName | null;
		const eventValue = clickableElement.getAttribute(DATA_VALUE);

		switch (eventName) {
			case 'copy-slip':
				if (eventValue) {
					event.preventDefault();
					const state: { event: HistoryEvent } = {
						event: { name: eventName, params: eventValue },
					};
					history.push(`/kupon-kibica?id=${eventValue}`, state);
				}
				break;
			default:
				console.warn(`Nieobsługiwane zdarzenie: ${eventName}`);
		}
	};
}
